module.exports = __webpack_public_path__ + "img/orgTree.f5a9a1d4.svg";